import { render, staticRenderFns } from "./MenuCollapseButton.vue?vue&type=template&id=782501dd&scoped=true"
import script from "./MenuCollapseButton.vue?vue&type=script&lang=js"
export * from "./MenuCollapseButton.vue?vue&type=script&lang=js"
import style0 from "./MenuCollapseButton.vue?vue&type=style&index=0&id=782501dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782501dd",
  null
  
)

export default component.exports